// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3bhqL","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1d3qA"};